export default "__VITE_ASSET__fd70dc32__"